import Checkbox from '@material-ui/core/Checkbox'
import React from 'react'
import Title from './Title'

export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  onChange = (e) => {
    this.props.onChange && this.props.onChange(e.target.checked, this.props.name)
  }

  render() {
    if (this.props.title !== undefined && this.props.title !== '') {
      return (
        <Title inline={this.props.inline} title={this.props.title}>
          <Checkbox
            style={this.props.style}
            className={this.props.className}
            disabled={this.props.disabled || false}
            checked={this.props.checked || false}
            onChange={this.onChange}
            color={this.props.color || "primary"}
          />
        </Title>
      )
    } else {
      return (
        <Checkbox
          style={this.props.style}
          className={this.props.className}
          disabled={this.props.disabled || false}
          checked={this.props.checked || false}
          onChange={this.onChange}
          color={this.props.color || "primary"}
        />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./app/Components/Checkbox.js